/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PromptConfigurationsControllerFindAllQueryResponse, PromptConfigurationsControllerFindAllQueryParams, PromptConfigurationsControllerFindAll401, PromptConfigurationsControllerFindAll403 } from "../../models/promptConfigurationsController/PromptConfigurationsControllerFindAll";

function getPromptConfigurationsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/prompt-configurations` as const }  
  return res
}

/**
 * @summary Get all prompt configurations with filtering and pagination
 * {@link /api/v1/prompt-configurations}
 */
export async function promptConfigurationsControllerFindAll(params?: PromptConfigurationsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PromptConfigurationsControllerFindAllQueryResponse, ResponseErrorConfig<PromptConfigurationsControllerFindAll401 | PromptConfigurationsControllerFindAll403>, unknown>({ method : "GET", url : getPromptConfigurationsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}